<template>
  <div class="mc-card">
    <div class="mc-list">
      <div v-for="(item, idx) in parsedItems" :key="idx" class="mc-item" :class="{ highlight: idx === parsedItems.length - 1 }">
        <div class="mc-label">{{ item.label }}</div>
        <div class="mc-value">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MetricCompare',
  props: {
    items: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedItems() {
      if (Array.isArray(this.items)) return this.items
      if (typeof this.items === 'string') {
        try {
          const parsed = JSON.parse(this.items)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.mc-card {
  padding: 0;
  background: transparent;
  border: none;
}

.mc-list {
  display: flex;
  gap: 10px;
}

.mc-item {
  flex: 1;
  min-width: 0;
  max-width: 300px;
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
}

.mc-label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
}

.mc-value {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.2;
}

.mc-item.highlight .mc-label {
  color: #ef4444;
}

.mc-item.highlight .mc-value {
  color: #ef4444;
}
</style>
